import { lazy } from "react";
import Loadable from "app/components/Loadable";

const BillingPage = Loadable(lazy(() => import("./BillingPage")));

const billingRoutes = [{ path: "/billing", element: <BillingPage /> }];

export default billingRoutes;
